/**
 * Runner-agnostic end-to-end test detection.
 *
 * Various parts of the app change behaviour under e2e tests — disabling
 * third-party analytics (Mixpanel/HubSpot/FullStory/Datadog), suppressing the
 * timezone-confirmation dialog, mocking feature flags, and skipping the
 * platform-connection redirect. Cypress exposes the global `window.Cypress`;
 * Playwright has no equivalent, so it sets `window.__E2E__`
 * (see `tests/playwright/fixtures/test.ts`). Prefer `isE2E()` over reading
 * `window.Cypress` directly so both runners are covered.
 */
declare global {
  interface Window {
    Cypress?: unknown;
    __E2E__?: boolean;
  }
}

/** True when running under any e2e runner (Cypress or Playwright). */
export function isE2E(): boolean {
  return Boolean(window.Cypress || window.__E2E__);
}
